if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          let interval = setInterval(() => {
            if(current < amount) {
                animate(createConfetti());
            }
        }, 50);
        
        setTimeout(() => clearInterval(interval), 4000);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// confetti
var amount = 60,
    between = (min, max) => min + Math.random() * (max - min),
    colors = ['#FBEFDF', '#775C50', '#FFA31A', '#E21BDA', '#775C50', '#FBEFDF'],
    current = 0;

function createConfetti() {
    let div = document.createElement('div');
    gsap.set(div, {
        attr: {
            class: 'confetti',
            style: '--color: ' + colors[Math.floor(Math.random() * colors.length)]
        },
        x: between(0, window.innerWidth),
        y: -window.innerHeight / 4,
        z: between(-80, 80)
    });
    current++;
    document.body.appendChild(div);
    return div;
}

function animate(element) {
    gsap.to(element, {
        y: window.innerHeight + 40,
        ease: 'power1.out',
        delay: between(0, .25),
        duration: between(2, 5),
        onComplete() {
            if(element instanceof Element || element instanceof HTMLDocument) {
                current--;
                element.remove();
            }
        }
    });
    gsap.to(element, {
        rotationZ: between(90, 180),
        repeat: -1,
        yoyo: true,
        duration: between(3, 6)
    });
    gsap.to(element, {
        rotationX: between(0, 360),
        rotationY: between(0, 360),
        repeat: -1,
        yoyo: true,
        duration: between(3, 6)
    });
}

// add Christmas deer

// (function () {
//   if (document.body.classList.contains('template_product')) {
//     const description = document.querySelector('.product__description')
//     const el = document.createElement('div')
//     el.classList.add('christmas_deer')
//     el.innerHTML = `
//     <div class="container_deer">
//   <div class="artboard">
//     <div class="deer">
//       <div class="rocking">
//         <div class="head">
//           <div class="horns">
//             <div class="horn horn-left">
//               <div class="line line-one"></div>
//               <div class="line"></div>
//               <div class="line line-three"></div>
//             </div>
//             <div class="horn horn-right">
//               <div class="line line-one"></div>
//               <div class="line"></div>
//               <div class="line line-three"></div>
//             </div>
//           </div>
//           <div class="ears">
//             <div class="ear ear-left"></div>
//             <div class="ear ear-right"></div>
//           </div>
//           <div class="eyes">
//             <div class="eye eye-left"></div>
//             <div class="eye eye-right"></div>
//           </div>
//           <div class="nose"></div>
//         </div>
//         <div class="body">
//           <div class="shadow"></div>
//           <div class="hooves">
//             <div class="hoof-one">
//               <div class="line"></div>
//               <div class="anim-part">
//                 <div class="circle">
//                   <div class="circle">
//                     <div class="circle">
//                       <div class="circle">
//                         <div class="circle circle-last"></div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div class="hoof-two">
//               <div class="line-one"></div>
//               <div class="line-two"></div>
//             </div>
//           </div>
//         </div>
//         <div class="tail">
//           <div class="circle">
//             <div class="circle">
//               <div class="circle">
//                 <div class="circle">
//                   <div class="circle"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div class="legs">
//         <div class="leg-left">
//           <div class="anim-part">
//             <div class="line"></div>
//           </div>
//         </div>
//         <div class="leg-right">
//           <div class="anim-part">
//             <div class="circle">
//               <div class="circle">
//                 <div class="circle">
//                   <div class="circle">
//                     <div class="circle">
//                       <div class="circle">
//                         <div class="circle">
//                           <div class="circle">
//                             <div class="circle circle-last"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div class="presents">
//       <div class="present present-one"></div>
//       <div class="present present-two"></div>
//       <div class="present present-two present-two-right"></div>
//       <div class="present present-three"></div>
//     </div>
//     <div class="snow"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//     <div class="snowflake"></div>
//   </div>
// </div>
//    `
//     description.append(el)
//   }
// })();